



































import Vue from 'vue';
import Modal from '@/components/modals/Modal.vue';
import { Button } from '@/components/ds';

export default Vue.extend({
  components: {
    Modal,
    Button,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    showCancelButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    cancelLabel: {
      type: String,
      default: 'Cancelar',
      required: false,
    },
    confirmButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    confirmWithErrors: {
      type: Boolean,
      default: false,
      required: false,
    },
    confirmLabel: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
  methods: {
    confirm(): void {
      this.closeDialog(true);
      if (this.confirmWithErrors) {
        this.$emit('confirmWithErrors');
      }
    },
    cancel(): void {
      this.closeDialog(false);
    },
    closeDialog(value: boolean) {
      this.$emit('close', value);
    },
    closeModalHandler() {
      this.$emit('abort');
    },
  },
});
